<div class="navbar-area" >
    <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" routerLink="/">
                <img src="assets/img/logo.png" style="width:200px " class="white-logo" alt="logo">
                <img src="assets/img/logo-black.png" style="width:200px " class="black-logo" alt="logo">
            </a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav" >
                    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Home </a></li>


                    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/about" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">About Us</a></li>

                    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/services" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Services</a></li>


                    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/projects" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Projects</a></li>
                    <li *ngIf=" this.isAuthenticated" class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/myEmails" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">All Emails</a></li>

                    <li class="nav-item" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show"><a routerLink="/contact" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">Contact</a></li>
                </ul>

                <div class="other-option" *ngIf="!isAuthenticated">
                    <a class="default-btn" routerLink="/Account/login">Login <span></span></a>
                </div>
                <div class="other-option" *ngIf="isAuthenticated">
                    <a class="default-btn" routerLink="/home">{{userData.userName}} <span></span></a>
                    <a class="default-btn btn-danger" (click)="logout()">logout <span></span></a>
                </div>
            </div>
        </nav>
    </div>
</div>
